import { RECEIVE_USER, SET_TOKEN } from '../constants';

const initialState = {};

const user = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_USER:
      return { ...state, ...action.user };
    case SET_TOKEN:
      return { ...state, token: action.token };
    default:
      return state;
  }
};

export default user;

export const getActiveSubscription = state => {
  return state.user.Subscriptions.find(sub => sub.Status === 'active');
};



// WEBPACK FOOTER //
// ./src/reducers/user.js